var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "720", persistent: _vm.saving },
      model: {
        value: _vm.dialogOpen,
        callback: function($$v) {
          _vm.dialogOpen = $$v
        },
        expression: "dialogOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              ref: "liveCollaborationConfigurationForm",
              attrs: {
                "lazy-validation": "",
                autocomplete: "off",
                onSubmit: "return false;"
              },
              on: { submit: _vm.save },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("v-card-title", { staticClass: "text-h6" }, [
                _vm._v(
                  _vm._s(
                    _vm.label(
                      "providers.liveCollaboration.title",
                      "Connect a Live Collaboration account"
                    )
                  )
                )
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.notBlank],
                              label: _vm.$t("providers.accountName"),
                              autocomplete: "new-password",
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.form.username,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "username", $$v)
                              },
                              expression: "form.username"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.required],
                              label: _vm.$t("providers.accountPassword"),
                              type: "password",
                              autocomplete: "new-password",
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.saving },
                      on: { click: _vm.onCancel }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.saving },
                      on: { click: _vm.save }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("providers.connect")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }